import type { ShoppingList, ShoppingSettings } from "@shared/types";
import { ProjectDocRepository } from "./ProjectDocRepository";

class ShoppingListRepository extends ProjectDocRepository<ShoppingList> {
  readonly key = "shopping-list";
  readonly defaultValue: ShoppingList = [];
}

class ShoppingSettingsRepository extends ProjectDocRepository<ShoppingSettings> {
  readonly key = "shopping-settings";
  readonly defaultValue: ShoppingSettings = { salesTaxRate: 0 };
}

export const shoppingListRepository = new ShoppingListRepository();
export const shoppingSettingsRepository = new ShoppingSettingsRepository();
